import { render, staticRenderFns } from "./BaseS3Uploader.vue?vue&type=template&id=22783fa5&scoped=true&"
import script from "./BaseS3Uploader.vue?vue&type=script&lang=js&"
export * from "./BaseS3Uploader.vue?vue&type=script&lang=js&"
import style0 from "./BaseS3Uploader.vue?vue&type=style&index=0&id=22783fa5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22783fa5",
  null
  
)

export default component.exports